import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';

interface EmptyStateProps {
  variant?: 'no-conversations' | 'no-selection';
}

export default function EmptyState({ variant = 'no-conversations' }: EmptyStateProps) {
  const isNoSelection = variant === 'no-selection';
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        px: 4,
        textAlign: 'center',
        bgcolor: '#F5F7FA',
      }}
    >
      {/* 아이콘 */}
      <Box
        sx={{
          width: 120,
          height: 120,
          borderRadius: '50%',
          bgcolor: 'rgba(13,31,60,0.06)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 3,
        }}
      >
        {isNoSelection ? (
          <ChatBubbleOutlineIcon sx={{ fontSize: 60, color: 'primary.main' }} />
        ) : (
          <MailOutlineIcon sx={{ fontSize: 60, color: 'primary.main' }} />
        )}
      </Box>

      {/* 제목 */}
      <Typography
        variant="h5"
        sx={{
          fontWeight: 600,
          color: 'text.primary',
          mb: 1.5,
          fontSize: { xs: '1.25rem', md: '1.5rem' },
        }}
      >
        {isNoSelection ? '대화를 선택해주세요' : '아직 쪽지가 없어요'}
      </Typography>

      {/* 설명 */}
      <Typography
        variant="body1"
        sx={{
          color: 'text.secondary',
          mb: 4,
          fontSize: { xs: '0.95rem', md: '1rem' },
          maxWidth: 400,
          lineHeight: 1.6,
        }}
      >
        {isNoSelection ? (
          <>왼쪽 목록에서 대화를 선택하면<br />메시지를 확인할 수 있어요!</>
        ) : (
          <>마음에 드는 큐피트카드에서<br />"쪽지 보내기"를 눌러 대화를 시작해보세요!</>
        )}
      </Typography>

      {/* CTA 버튼 */}
      {!isNoSelection && (
        <Button
          variant="contained"
          size="large"
          startIcon={<FavoriteBorderIcon />}
          onClick={() => window.location.href = '/dashboard'}
          sx={{
            fontSize: '1rem',
            py: 1.5,
            px: 4,
            borderRadius: 3,
            bgcolor: 'primary.main',
            '&:hover': {
              bgcolor: 'primary.dark',
              transform: 'translateY(-2px)',
              boxShadow: 3,
            },
            transition: 'all 0.2s',
          }}
        >
          큐피트카드 보러가기
        </Button>
      )}
    </Box>
  );
}
